import { openContentUrl } from "screens/Root/actions/contentTabActions";
import { loginUrl } from "screens/Root/utils/constants";
import { useDispatch } from "react-redux";
import { IconButton } from "../../components/IconButton";
const HeaderLoginIcon = () => {
    const dispatch = useDispatch();
    const handleClick = () => dispatch(openContentUrl(loginUrl, "Login"));
    return (<IconButton type="font-awesome" onClick={handleClick} title="LOGIN" identification="header-login">
      sign-in
    </IconButton>);
};
export default HeaderLoginIcon;
